import { RuleValueFormatDisplayName } from "constants/ruleBooks";
import { useFieldValue } from "hooks";
import { Row } from "components/Layout";
import { SubtleBadge } from "components/Badge";
import { CollapseLabel } from "components/Form";
import React from "react";

export function PresentationFormattingHeader() {
  const unitFormat =
    RuleValueFormatDisplayName[useFieldValue("quantity_output_format")];
  const unitPriceFormat =
    RuleValueFormatDisplayName[useFieldValue("unit_amount_output_format")];
  const includeIfZero = useFieldValue("include_if_zero");
  return (
    <Row>
      <div>
        <SubtleBadge>Presentation &amp; Formatting</SubtleBadge>
      </div>
      <Row alignCenter flexWrap>
        <CollapseLabel>
          {unitFormat} * {unitPriceFormat}
        </CollapseLabel>
      </Row>
      {includeIfZero && (
        <Row alignCenter flexWrap>
          <CollapseLabel>Always included</CollapseLabel>
        </Row>
      )}
    </Row>
  );
}
